import { TriangleAlertIcon } from 'lucide-react'

type Props = {
  errorMessage?: string
}

export const OAuthError = ({ errorMessage }: Props) => (
  <>
    <div className="mt-auto w-min rounded-full border-2 border-red-600 bg-red-50 p-6">
      <TriangleAlertIcon className="h-16 w-16 text-red-500" />
    </div>

    <span className="mt-6 text-lg text-neutral-900">Authentication failed! Please try again</span>
    {errorMessage && <span className="text-sm text-neutral-900">{errorMessage}</span>}
  </>
)
